module.exports = __webpack_public_path__ + "static/img/hy2.ef00557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/hy2.png
// module id = TBJz
// module chunks = 2